const format = (key) => {
    return key.charAt(0) + key.toLowerCase().replaceAll("_", " ").substring(1);
};

export default format;
